import i18n from '~shared/utils/i18n';
import { isBetfeedPageEnabled, isBetfeedWidgetEnabled } from '~scenes/betfeed/app/utils';
import { getVirtualGames, getVirtualGameBySlug } from '~shared/services/virtuals';
import { ALL_CAROUSEL_ITEMS, SPORT_PAGE_TABS } from './constants';
import { VIRTUAL_GENERIC_SLUG_MAPPINGS } from '~spa/Pages/VirtualSports/constants';
import { getSportsPageSeoUrl } from '../../Utils/SeoUrls';
import { GENERIC_LAYOUT_SPORTS } from '~shared/utils/constants';

/**
 * Filter the list of carousel items in case, e.g. a virtual game is disabled
 * @todo AM-5411 - this function will be removed from sports page redesign v4
 * @param {String} sportSlug the sport
 * @param {number} sportId sport id
 * @returns {Object} the filtered list
 */
export const filterCarouselItems = async (sportSlug, sportId) => {
    const filteredItems = { ...ALL_CAROUSEL_ITEMS };

    let virtuals = {};
    const virtualGames = await getVirtualGames();
    if (!virtualGames.length) {
        delete filteredItems[SPORT_PAGE_TABS.VIRTUALS];
    } else {
        const virtualGameSlug = VIRTUAL_GENERIC_SLUG_MAPPINGS[sportSlug];
        virtuals = getVirtualGameBySlug(virtualGames, virtualGameSlug);
        const noVirtuals = !Object.keys(virtuals).length;
        if (noVirtuals) {
            delete filteredItems[SPORT_PAGE_TABS.VIRTUALS];
        }
    }

    if (!isBetfeedWidgetEnabled() || !isBetfeedPageEnabled()) {
        delete filteredItems[SPORT_PAGE_TABS.POPULAR_BETS];
    }

    const carouselItems = Object.keys(filteredItems).map((slug) => {
        const display = i18n.t(`${filteredItems[slug].i18nKey}`);
        const url = getSportsPageSeoUrl(sportSlug, slug, sportId);

        return {
            display,
            slug,
            url,
        };
    });

    return {
        carouselItems,
        virtuals,
    };
};

/**
 * Check is the sport to be displayed in the
 * generic v2 layout
 * @param {string} sportSlug sport slug
 * @returns {boolean} is it for generic v2 layout?
 */
export const isGenericSportV2 = (sportSlug) => GENERIC_LAYOUT_SPORTS.includes(sportSlug);
